module.exports = __webpack_public_path__ + "static/media/menu.6b493a69.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/menu.svg
// module id = 1163
// module chunks = 0